import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import snackbarReducer from "./snackbarSlice";
import templateReducer from "./slices/templateSlice";
import fontsReducer from "./slices/fontsSlice";
import systemFieldsReducer from "./slices/systemFieldsSlice";
import eventTypeReducer from "./slices/eventTypeSlice";

export const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    template: templateReducer,
    fonts: fontsReducer,
    systemFields: systemFieldsReducer,
    eventType: eventTypeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
